const config = {
    socketUrl: 'http://localhost:9527',
    getHexUrl: board => `http://static-robobloq-dev.oss-cn-shenzhen.aliyuncs.com/test/${board}.hex`
};
export {
    config
};
